import { Link } from "react-router-dom";

import { PlatformPageHeader } from "@/components/PlatformLayout";
import { useTranslation } from "react-i18next";

import { usePlatformKpis } from "@/lib/platform";

export default function PlatformLandingPage() {
  const { t } = useTranslation();
  const kpis = usePlatformKpis();

  return (
    <div className="space-y-6">
      <PlatformPageHeader title={t("platform.nav.overview")} description={t("platform.landing.desc")} />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <KpiCard
          label={t("platform.kpi.totalOrgs")}
          value={kpis.data?.total_orgs ?? "—"}
          tone="slate"
        />
        <KpiCard
          label={t("platform.kpi.verified")}
          value={kpis.data?.verified_orgs ?? "—"}
          tone="ok"
        />
        <KpiCard
          label={t("platform.kpi.flagged")}
          value={kpis.data?.flagged_orgs ?? "—"}
          tone="danger"
        />
        <KpiCard
          label={t("platform.kpi.openSessions")}
          value={kpis.data?.open_sessions ?? "—"}
          tone="accent"
        />
      </div>

      <section
        className="rounded-md border border-nb-border bg-nb-surface p-4"
        aria-labelledby="quick-actions-heading"
      >
        <h2
          id="quick-actions-heading"
          className="mb-3 text-sm font-semibold uppercase tracking-wide text-nb-mute"
        >
          {t("platform.landing.quickActions")}
        </h2>
        <ul className="space-y-2 text-sm">
          <li>
            <Link
              to="/platform/orgs?kyc=pending"
              className="text-nb-accent hover:underline"
            >
              {t("platform.landing.reviewKyb")}
            </Link>
          </li>
          <li>
            <Link
              to="/platform/orgs?flagged=1"
              className="text-nb-accent hover:underline"
            >
              {t("platform.landing.reviewFlagged")}
            </Link>
          </li>
          <li>
            <Link
              to="/platform/audit"
              className="text-nb-accent hover:underline"
            >
              {t("platform.landing.recentActions")}
            </Link>
          </li>
        </ul>
      </section>
    </div>
  );
}

function KpiCard({
  label,
  value,
  tone,
}: {
  label: string;
  value: number | string;
  tone: "slate" | "ok" | "danger" | "accent";
}) {
  const toneClass = {
    slate: "border-nb-border bg-nb-surface",
    ok: "border-nb-ok/40 bg-nb-ok/5",
    danger: "border-nb-danger/40 bg-nb-danger/5",
    accent: "border-nb-accent/40 bg-nb-accent/5",
  }[tone];
  return (
    <div className={`rounded-md border p-4 ${toneClass}`}>
      <div className="text-xs uppercase tracking-wide text-nb-mute">
        {label}
      </div>
      <div className="mt-1 text-2xl font-semibold text-nb-text">{value}</div>
    </div>
  );
}
